import { Spinner, Typography } from '@material-tailwind/react';
import moment from 'moment';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useViewComparisonQuery } from '../../../store/auth/authService';
import FilterComparison from './FilterComparison';
import TableLayout from '../../../layouts/pagesLayouts/TableLayout';
import TabController from './TabController';
import { classCharContainerHeight, classCharDoughnutContainerHeight, TAB_0_GRAPH_1_ID, TAB_0_GRAPH_2_ID, TAB_1_GRAPH_1_ID, TAB_1_GRAPH_2_ID, TAB_2_GRAPH_1_ID, TAB_2_GRAPH_2_ID } from '../common';
import { save2picture } from '../../../utils/utils';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import axios from 'axios';
import { baseApi } from '../../../ConfigApi';
import { errorToast } from '../../../components/toasts/toasts';
import fileDownload from 'js-file-download';
import { ComparisonFormType } from '../common.types';



const ViewComparison = ({ isMobile }: { isMobile: boolean }) => {

    const { t } = useTranslation()

    const { param_contract_id } = useParams<{
        param_contract_id: string;
    }>()

    const { token } = useSelector((state: RootState) => state.auth)
    const { or_number } = useSelector((state: RootState) => state.contract)

    // ключи из рута consumption-comparison/view
    const tabs = ['consumption', 'dataPrice', 'dataTotal']

    const [selectedTab, setSelectedTab] = useState(tabs[0]);

    const defaulPeriod1 = moment().add(-2, 'month').format('MM-YYYY')
    const defaulPeriod2 = moment().add(-1, 'month').format('MM-YYYY')


    const form: ComparisonFormType = {
        contract_id: Number(param_contract_id) || 0,
        periodFrom1: defaulPeriod1,
        periodTo1: defaulPeriod1,
        periodFrom2: defaulPeriod2,
        periodTo2: defaulPeriod2
    }


    const [sendForm, setSendForm] = useState<ComparisonFormType>(form);

    // sendForm
    const { currentData, error, isFetching } = useViewComparisonQuery<any>(sendForm)

    const setFormForFetch = (values: any) => {
        setSendForm(prev => ({
            ...prev, ...{
                ...values,
                contract_id: param_contract_id
            }
        }))
    }

    const saveExcel13 = (callback?: any) => {
        axios.post(`${baseApi}/api/analitic/build-excel-report-type-10`, {
            ...sendForm,
            typeReport: 13,
        },
            {
                responseType: 'blob',
                headers: {
                    'Authorization': token,
                }
            })
            .then((response: any) => {
                if (response.data.res === 'Error') {
                    errorToast({
                        title: t('analytics.build_excel_report'),
                        text: t('analytics.build_excel_report_error')
                    })
                }
                else {
                    fileDownload(response.data, `${t('analytics.build_excel_report_13')} ${sendForm.periodFrom1}-${sendForm.periodTo1}, ${sendForm.periodFrom2}-${sendForm.periodTo2}.xlsx`)
                }
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('analytics.build_excel_report'),
                    text: t('analytics.build_excel_report_error')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }
    const saveExcel11 = (callback?: any) => {
        axios.post(`${baseApi}/api/analitic/build-excel-report-type-10`, {
            ...sendForm,
            typeReport: 11,
        },
            {
                responseType: 'blob',
                headers: {
                    'Authorization': token,
                }
            })
            .then((response: any) => {
                if (response.data.res === 'Error') {
                    errorToast({
                        title: t('analytics.build_excel_report'),
                        text: t('analytics.build_excel_report_error')
                    })
                }
                else {
                    fileDownload(response.data, `${t('analytics.build_excel_report_11')} ${sendForm.periodFrom1}-${sendForm.periodTo1}, ${sendForm.periodFrom2}-${sendForm.periodTo2}.xlsx`)
                }
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('analytics.build_excel_report'),
                    text: t('analytics.build_excel_report_error')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }
    const saveExcel10 = (callback?: any) => {
        axios.post(`${baseApi}/api/analitic/build-excel-report-type-10`, {
            ...sendForm,
            typeReport: 10,
        },
            {
                responseType: 'blob',
                headers: {
                    'Authorization': token,
                }
            })
            .then((response: any) => {
                if (response.data.res === 'Error') {
                    errorToast({
                        title: t('analytics.build_excel_report'),
                        text: t('analytics.build_excel_report_error')
                    })
                }
                else {
                    fileDownload(response.data, `${t('analytics.build_excel_report_10')} ${sendForm.periodFrom1}-${sendForm.periodTo1}, ${sendForm.periodFrom2}-${sendForm.periodTo2}.xlsx`)
                }
            })
            .catch(error => {
                console.error(error);
                errorToast({
                    title: t('analytics.build_excel_report'),
                    text: t('analytics.build_excel_report_error')
                })
            })
            .finally(() => {
                if (callback) callback()
            })
    }

    return (
        <div>
            <Typography variant='lead' className='text-gray-800 text-left tab:text-center text-[24px] lap:text-[32px] font-medium leading-[1.2]'>
                {t('analytics.analytics_comparison_title')}
            </Typography>
            <canvas id='save2pictureCanvas' className={` !w-full ${classCharDoughnutContainerHeight} z-[-1] absolute point-events-none opacity-0`} />
            <FilterComparison
                value={{
                    periodFrom1: sendForm.periodFrom1,
                    periodTo1: sendForm.periodTo1,
                    periodFrom2: sendForm.periodFrom2,
                    periodTo2: sendForm.periodTo2,
                }}
                isLoadingFetch={isFetching}
                fetchPage={setFormForFetch}
                savePictures={() => {
                    if (selectedTab === tabs[0]) {
                        save2picture(
                            TAB_0_GRAPH_1_ID,
                            TAB_0_GRAPH_2_ID,
                            `${t('or')} ${or_number} - ${t('analytics.consumption')} ${t('by_period')} ${sendForm.periodFrom1}-${sendForm.periodTo1}.png`,
                            `${t('or')} ${or_number} - ${t('analytics.consumption')} ${t('by_period')} ${sendForm.periodFrom2}-${sendForm.periodTo2}.png`,
                            `${t('or')} ${or_number} - ${t('analytics.consumption')} ${t('by_period')} ${sendForm.periodFrom1}-${sendForm.periodTo1}, ${sendForm.periodFrom2}-${sendForm.periodTo2}.png`,
                        )
                    }
                    if (selectedTab === tabs[1]) {
                        save2picture(
                            TAB_1_GRAPH_1_ID,
                            TAB_1_GRAPH_2_ID,
                            `${t('or')} ${or_number} - ${t('analytics.dataPrice')} ${t('by_period')} ${sendForm.periodFrom1}-${sendForm.periodTo1}.png`,
                            `${t('or')} ${or_number} - ${t('analytics.dataPrice')} ${t('by_period')} ${sendForm.periodFrom2}-${sendForm.periodTo2}.png`,
                            `${t('or')} ${or_number} - ${t('analytics.dataPrice')} ${t('by_period')} ${sendForm.periodFrom1}-${sendForm.periodTo1}, ${sendForm.periodFrom2}-${sendForm.periodTo2}.png`
                        )
                    }
                    if (selectedTab === tabs[2]) {
                        save2picture(
                            TAB_2_GRAPH_1_ID,
                            TAB_2_GRAPH_2_ID,
                            `${t('or')} ${or_number} - ${t('analytics.dataTotal')} ${t('by_period')} ${sendForm.periodFrom1}-${sendForm.periodTo1}.png`,
                            `${t('or')} ${or_number} - ${t('analytics.dataTotal')} ${t('by_period')} ${sendForm.periodFrom2}-${sendForm.periodTo2}.png`,
                            `${t('or')} ${or_number} - ${t('analytics.dataTotal')} ${t('by_period')} ${sendForm.periodFrom1}-${sendForm.periodTo1}, ${sendForm.periodFrom2}-${sendForm.periodTo2}.png`
                        )
                    }
                }}
                saveExcel={(callback: any) => {
                    if (selectedTab === tabs[0]) {
                        saveExcel13(callback)
                    }
                    if (selectedTab === tabs[1]) {
                        saveExcel11(callback)
                    }
                    if (selectedTab === tabs[2]) {
                        saveExcel10(callback)
                    }
                }}
                disabledSave={
                    isFetching ? true :
                        selectedTab === tabs[0] ?
                            ((currentData?.formatted?.period1[tabs[0]].declared === 0 && currentData?.formatted?.period1[tabs[0]].fact === 0) && (currentData?.formatted?.period2[tabs[0]].declared === 0 && currentData?.formatted?.period2[tabs[0]].fact === 0))
                            :
                            selectedTab === tabs[1] ?
                                !(!(currentData?.formatted?.period1[tabs[1]].values.length === 0) || !(currentData?.formatted?.period2[tabs[1]].values.length === 0))
                                :
                                selectedTab === tabs[2] ?
                                    !(!(currentData?.formatted?.period1[tabs[2]].values.length === 0) || !(currentData?.formatted?.period2[tabs[2]].values.length === 0))
                                    :
                                    true
                }
            />
            {
                currentData?.formatted ?
                    <div className='bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px]'>
                        {/* <div className={classComparisonContainerHeight}> */}
                        <TabController
                            currentData={currentData?.formatted}
                            period1={sendForm.periodFrom1 + ' — ' + sendForm.periodTo1}
                            period2={sendForm.periodFrom2 + ' — ' + sendForm.periodTo2}
                            isMobile={isMobile}
                            selectedTab={selectedTab}
                            setSelectedTab={setSelectedTab}
                            tabs={tabs}
                        />
                        {/* </div> */}
                    </div>
                    :
                    isFetching ?
                        <div className={`${classCharContainerHeight} bg-white border-2 border-gray-200 rounded-[16px] lap:rounded-[24px] p-[24px] lap:p-[32px] flex justify-center items-center`}>
                            <Spinner />
                        </div>
                        :
                        error ?
                            <TableLayout>
                                <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                                    {t('tables.error_on_loading')}
                                </Typography>
                            </TableLayout>
                            :
                            <Typography variant='lead' className='text-[16px] lap:text-[20px] font-medium text-center my-[40px]'>
                                {t('analytics.month_detailing_no_data')}
                            </Typography>
            }
        </div>
    )
}

export default ViewComparison